import{isFunction}from"../../util/Lang";export function isEditableStore(i){return isFunction(i.add)&&isFunction(i.put)&&isFunction(i.remove)}